module.exports = __webpack_public_path__ + "static/media/dabbl-logo.92b638b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/dabbl-logo.png
// module id = 122
// module chunks = 0